import React, { useState } from 'react';

const withControlledOpen = Component => {
  const Composed = props => {
    const [isDropDownOpen, setOpen] = useState(false);

    const closeDropDown = () => setOpen(false);
    const openDropDown = () => setOpen(true);

    return (
      <Component
        {...props}
        open={isDropDownOpen}
        handleOnBlur={closeDropDown}
        onFocus={openDropDown}
      />
    );
  };
  return Composed;
};

export default withControlledOpen;
